import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppMaterialModule } from "src/app/app.material.module";
import { SharedModule } from "../../shared.module";
import { PatientAutoCompleteComponent } from "./patient-autocomplete.component";

@NgModule({
  declarations: [PatientAutoCompleteComponent],
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [PatientAutoCompleteComponent],
})
export class PatientAutocompleteModule {}
